import React, { useEffect, useState } from 'react'

interface MarkdownProps {
  content: string
  className?: string
}

// Lightweight Markdown renderer. We dynamically import react-markdown if available in the runtime.
export default function Markdown({ content, className }: MarkdownProps) {
  // Simple markdown -> HTML conversions for headings, bold, italics and line breaks
  const escaped = content
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
  const html = escaped
    .replace(/^### (.*$)/gim, '<h3>$1</h3>')
    .replace(/^## (.*$)/gim, '<h2>$1</h2>')
    .replace(/^# (.*$)/gim, '<h1>$1</h1>')
    .replace(/\*\*(.*?)\*\*/gim, '<strong>$1</strong>')
    .replace(/\*(.*?)\*/gim, '<em>$1</em>')
    .replace(/\[(.*?)\]\((.*?)\)/gim, '<a href="$2" target="_blank" rel="noreferrer">$1</a>')
    .replace(/\n/g, '<br />')

  return <div className={className} dangerouslySetInnerHTML={{ __html: html }} />
}
